 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import FRONT_COVER from '@/components/Front_Cover'
 import LOVE_1 from '@/components/love_1'
 import TITLE_PAGE from '@/components/title_page'
 import DED01 from '@/components/ded01'
 import EPI01 from '@/components/epi01'
 import CONTENTS from '@/components/contents'
 import FM01 from '@/components/fm01'
 import INTRO01 from '@/components/intro01'
 import CH01 from '@/components/ch01'
 import CH02 from '@/components/ch02'
 import CH03 from '@/components/ch03'
 import CH04 from '@/components/ch04'
 import CH05 from '@/components/ch05'
 import CH06 from '@/components/ch06'
 import CH07 from '@/components/ch07'
 import CH08 from '@/components/ch08'
 import CH09 from '@/components/ch09'
 import CH10 from '@/components/ch10'
 import CH11 from '@/components/ch11'
 import LOVE_2 from '@/components/love_2'
 import BM01 from '@/components/bm01'
 import EXCERPT1 from '@/components/Excerpt1'
 import EXCERPT1A from '@/components/Excerpt1a'
 import ATA01 from '@/components/ata01'
 import CREDIT01 from '@/components/credit01'
 import COPY01 from '@/components/copy01'
 import ATP01 from '@/components/atp01'
 import FOOTNOTE01 from '@/components/footnote01'
 import FOOTNOTE02 from '@/components/footnote02'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/fm01",
 			"name" : "fm01",
 			"component" : FM01
 		},
 		{
 			"path" : "/intro01",
 			"name" : "intro01",
 			"component" : INTRO01
 		},
 		{
 			"path" : "/ch01",
 			"name" : "ch01",
 			"component" : CH01
 		},
 		{
 			"path" : "/ch02",
 			"name" : "ch02",
 			"component" : CH02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js